module.exports = __webpack_public_path__ + "static/media/janssen.293c874f.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/janssen.png
// module id = 130
// module chunks = 0